/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/heading-has-content */
import React, { useState } from "react";
import { PageBase } from "../../Components/PageBase";
import { useRol } from "../../Context";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock, faMoneyBillWave, faMoneyBill } from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import "./Afinidad.css"

const BASE_URL = process.env.REACT_APP_API_URL || '';

const nseRanges = {
    'Económico':  [
        { label: 'Mínimo', value: '$400k–$490k' },
        { label: 'Bajo',   value: '$500k–$780k' },
        { label: 'Medio',  value: '$790k–$890k' },
    ],
    'Medio': [
        { label: 'Mínimo', value: '$790k–$890k' },
        { label: 'Bajo',   value: '$900k–$1.29M' },
        { label: 'Medio',  value: '$1.3M–$1.9M' },
    ],
    'Residencial': [
        { label: 'Mínimo', value: '$1.5M–$1.99M' },
        { label: 'Bajo',   value: '$2M–$2.5M' },
        { label: 'Medio',  value: '$2.6M–$3M' },
        { label: 'Alto',   value: '$3.1M–$3.5M' },
        { label: 'Máximo', value: '$3.6M–$4.2M' },
    ],
    'Plus': [
        { label: 'Mínimo', value: '$3.6M–$4.2M' },
        { label: 'Bajo',   value: '$4.3M–$6M' },
        { label: 'Medio',  value: '$6.5M–$9M' },
        { label: 'Alto',   value: '$10M–$14M' },
    ],
    'Plus AAA': [
        { label: 'Mínimo', value: '$8M–$9.9M' },
        { label: 'Bajo',   value: '$10M–$15M' },
        { label: 'Medio',  value: '$15M–$20M' },
        { label: 'Alto',   value: '$20M–$30M' },
    ],
};

function Afinidad() {
    const { idProject } = useRol();

    // opciones de NSE
    const [opcionSeleccionada, setOpcionSeleccionada] = useState('Económico');
    const handleSelectChange = (event) => {
        const value = event.target.value;
        setOpcionSeleccionada(value);
        if (value && idProject) {
            fetch(`${BASE_URL}/api/projects/${idProject}`, {
                method: 'PATCH',
                mode: 'cors',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ nse: value }),
            })
                .then(response => response.json())
                .catch(error => console.error('Error al actualizar NSE:', error));
        }
    };

    // opciones de Califacacion
    const [opcionSeleccionadaRanger, setOpcionSeleccionadaRanger] = useState('1');
    const handleSelectChangeRanger = (event) => {
        setOpcionSeleccionadaRanger(event.target.value);
    };

    const handleLiClick = (value) => {
        setOpcionSeleccionadaRanger(value);
    };

    const [compra, setCompra] = useState(25);
    const [pago, setPago] = useState(20);
    const [presupuesto, setPresupuesto] = useState(5);
    const [medio, setMedio] = useState(0);
    const [contado, setContado] = useState(25);
    const [infonavit, setInfonavit] = useState(5);
    const [credito, setCredito] = useState(0);
    const [cofinanciamiento, setCofinanciamiento] = useState(20);
    const [otro, setOtro] = useState(5);
    const [cuatro, setCuatro] = useState(1);
    const [cinco, setCinco] = useState(14);
    const [siete, setSiete] = useState(0);
    const [correo, setCorreo] = useState(0);
    const [telefono, setTelefono] = useState(25);
    const [whatsapp, setWhatsapp] = useState(5);


    const handleRangeChange = (event) => {
        setMedio(parseInt(event.target.value));
    };

    const handleRangeChange2 = (event) => {
        setPresupuesto(parseInt(event.target.value));
    };

    const handleRangeChange3 = (event) => {
        setPago(parseInt(event.target.value));
    };

    const handleRangeChange4 = (event) => {
        setCompra(parseInt(event.target.value));
    };

    const handleRangeChange5 = (event) => {
        setContado(parseInt(event.target.value));
    };

    const handleRangeChange6 = (event) => {
        setInfonavit(parseInt(event.target.value));
    };

    const handleRangeChange7 = (event) => {
        setCredito(parseInt(event.target.value));
    };

    const handleRangeChange8 = (event) => {
        setCofinanciamiento(parseInt(event.target.value));
    };

    const handleRangeChange9 = (event) => {
        setOtro(parseInt(event.target.value));
    };

    const handleRangeChange10 = (event) => {
        setCuatro(parseInt(event.target.value));
    };

    const handleRangeChange11 = (event) => {
        setCinco(parseInt(event.target.value));
    };

    const handleRangeChange12 = (event) => {
        setSiete(parseInt(event.target.value));
    };

    const handleRangeChange13 = (event) => {
        setCorreo(parseInt(event.target.value));
    };

    const handleRangeChange14 = (event) => {
        setTelefono(parseInt(event.target.value));
    };

    const handleRangeChange15 = (event) => {
        setWhatsapp(parseInt(event.target.value));
    };

    const spanStyle = {
        left: `${(medio * 100) / 25}%`,
    };

    const spanStyle2 = {
        left: `${(presupuesto * 100) / 25}%`,
    };

    const spanStyle3 = {
        left: `${(pago * 100) / 25}%`,
    };

    const spanStyle4 = {
        left: `${(compra * 100) / 25}%`,
    };

    const spanStyle5 = {
        left: `${(contado * 100) / 25}%`,
    };

    const spanStyle6 = {
        left: `${(infonavit * 100) / 25}%`,
    };

    const spanStyle7 = {
        left: `${(credito * 100) / 25}%`,
    };

    const spanStyle8 = {
        left: `${(cofinanciamiento * 100) / 25}%`,
    };

    const spanStyle9 = {
        left: `${(otro * 100) / 25}%`,
    };

    const spanStyle10 = {
        left: `${(cuatro * 100) / 25}%`,
    };

    const spanStyle11 = {
        left: `${(cinco * 100) / 25}%`,
    };

    const spanStyle12 = {
        left: `${(siete * 100) / 25}%`,
    };

    const spanStyle13 = {
        left: `${(correo * 100) / 25}%`,
    };

    const spanStyle14 = {
        left: `${(telefono * 100) / 25}%`,
    };

    const spanStyle15 = {
        left: `${(whatsapp * 100) / 25}%`,
    };

    return (
        <>
            <PageBase />
            <div className="main-content">
                <div className="afinidad-page">
                <div className="afinidad-container">
                    <div className="afinidad-porlet-card">
                        <div className="indicadores-coord-header">
                            <div className="indicadores-coord-header-text">
                                <label>Selecciona el NSE de tu desarrollo</label>
                                <span>El nivel socio económico determina la capacidad de compra de tus prospectos. Selecciona a cual pertenece tu desarrollo.</span>
                            </div>
                            <select className="equipo-periodo-select" value={opcionSeleccionada} onChange={handleSelectChange}>
                                <option value="">Selecciona una opción</option>
                                <option value="Económico">Económico</option>
                                <option value="Medio">Medio</option>
                                <option value="Residencial">Residencial</option>
                                <option value="Plus">Plus</option>
                                <option value="Plus AAA">Plus AAA</option>
                            </select>
                        </div>
                        <div className="nse-container">
                            {opcionSeleccionada && nseRanges[opcionSeleccionada] && (
                                <div className="nse-price-range">
                                    <div className="nse-price-wrapper">
                                        <svg className="nse-price-icon" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <circle cx="12" cy="20" r="9" fill="#e8c840" stroke="#c9a800" strokeWidth="1.5"/>
                                            <text x="12" y="24.5" textAnchor="middle" fontSize="10" fill="#8a6d00" fontWeight="bold">$</text>
                                            <circle cx="20" cy="14" r="9" fill="#f0d050" stroke="#c9a800" strokeWidth="1.5"/>
                                            <text x="20" y="18.5" textAnchor="middle" fontSize="10" fill="#8a6d00" fontWeight="bold">$</text>
                                        </svg>
                                        <div className="nse-price-bar-area">
                                            <div className="nse-price-points-row">
                                                {nseRanges[opcionSeleccionada].map((t, i) => (
                                                    <div key={i} className="nse-price-point-col">
                                                        <span className="nse-price-bubble">{t.value}</span>
                                                        <span className="nse-price-dot" />
                                                        <span className="nse-price-tier-label">{t.label}</span>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                        <svg className="nse-price-icon" viewBox="0 0 36 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect x="1" y="5" width="34" height="20" rx="3" fill="#85bb65" stroke="#5a8a3c" strokeWidth="1.5"/>
                                            <rect x="3" y="3" width="34" height="20" rx="3" fill="#97cc74" stroke="#5a8a3c" strokeWidth="1.5"/>
                                            <rect x="5" y="1" width="34" height="20" rx="3" fill="#a8d882" stroke="#5a8a3c" strokeWidth="1.5"/>
                                            <text x="22" y="15" textAnchor="middle" fontSize="9" fill="#2d5a1b" fontWeight="bold">$$$</text>
                                        </svg>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className="afinidad-container div2">
                    <div className="afinidad-porlet-card">
                        <div className="indicadores-coord-header">
                            <div className="indicadores-coord-header-text">
                                <label>Califica las respuestas de los contactos</label>
                                <span>Asigna una puntuación basada en las preguntas de perfilación. Esto nos ayudará a entender mejor cuales son tus potenciales clientes y concretar más ventas.</span>
                            </div>
                        </div>
                        <div className="afinidad-porlet-body">
                            <div className="afinidad-calific">
                                <div className="afinidad-calific-title">
                                    <button className={`afinidad-tab${opcionSeleccionadaRanger === '1' ? ' afinidad-tab--active' : ''}`} onClick={() => handleLiClick('1')}>
                                        <FontAwesomeIcon icon={faClock} className="afinidad-tab-icon" />
                                        Tiempo de compra
                                    </button>
                                    <button className={`afinidad-tab${opcionSeleccionadaRanger === '2' ? ' afinidad-tab--active' : ''}`} onClick={() => handleLiClick('2')}>
                                        <FontAwesomeIcon icon={faMoneyBillWave} className="afinidad-tab-icon" />
                                        Forma de pago
                                    </button>
                                    <button className={`afinidad-tab${opcionSeleccionadaRanger === '3' ? ' afinidad-tab--active' : ''}`} onClick={() => handleLiClick('3')}>
                                        <FontAwesomeIcon icon={faMoneyBill} className="afinidad-tab-icon" />
                                        Presupuesto disponible
                                    </button>
                                    <button className={`afinidad-tab${opcionSeleccionadaRanger === '4' ? ' afinidad-tab--active' : ''}`} onClick={() => handleLiClick('4')}>
                                        <FontAwesomeIcon icon={faWhatsapp} className="afinidad-tab-icon" />
                                        Medio de contacto
                                    </button>
                                </div>
                                {opcionSeleccionadaRanger === '1' && <div className="afinidad-calific-range">
                                    <div className="afinidad-bar">
                                        <p><span>0</span><span>25</span></p>
                                        <div className="afinidad-bar-track" style={{ position: 'relative' }}>
                                            <span className="value" style={spanStyle4}>{compra}</span>
                                            <input type="range" value={compra} min="0" max="25" onChange={handleRangeChange4} style={{ zIndex: 1 }} />
                                        </div>
                                        <label>Tres meses</label>
                                    </div>
                                    <div className="afinidad-bar">
                                        <p><span>0</span><span>25</span></p>
                                        <div className="afinidad-bar-track" style={{ position: 'relative' }}>
                                            <span className="value" style={spanStyle3}>{pago}</span>
                                            <input type="range" value={pago} min="0" max="25" onChange={handleRangeChange3} style={{ zIndex: 1 }} />
                                        </div>
                                        <label>Seis meses</label>
                                    </div>
                                    <div className="afinidad-bar">
                                        <p><span>0</span><span>25</span></p>
                                        <div className="afinidad-bar-track" style={{ position: 'relative' }}>
                                            <span className="value" style={spanStyle2}>{presupuesto}</span>
                                            <input type="range" value={presupuesto} min="0" max="25" onChange={handleRangeChange2} style={{ zIndex: 1 }} />
                                        </div>
                                        <label>Un año</label>
                                    </div>
                                    <div className="afinidad-bar">
                                        <p><span>0</span><span>25</span></p>
                                        <div className="afinidad-bar-track" style={{ position: 'relative' }}>
                                            <span className="value" style={spanStyle}>{medio}</span>
                                            <input type="range" value={medio} min="0" max="25" onChange={handleRangeChange} style={{ zIndex: 1 }} />
                                        </div>
                                        <label>No estoy seguro</label>
                                    </div>
                                </div>}
                                {opcionSeleccionadaRanger === '2' && <div className="afinidad-calific-range">
                                    <div className="afinidad-bar">
                                        <p><span>0</span><span>25</span></p>
                                        <div className="afinidad-bar-track" style={{ position: 'relative' }}>
                                            <span className="value" style={spanStyle5}>{contado}</span>
                                            <input type="range" value={contado} min="0" max="25" onChange={handleRangeChange5} style={{ zIndex: 1 }} />
                                        </div>
                                        <label>Contado</label>
                                    </div>
                                    <div className="afinidad-bar">
                                        <p><span>0</span><span>25</span></p>
                                        <div className="afinidad-bar-track" style={{ position: 'relative' }}>
                                            <span className="value" style={spanStyle6}>{infonavit}</span>
                                            <input type="range" value={infonavit} min="0" max="25" onChange={handleRangeChange6} style={{ zIndex: 1 }} />
                                        </div>
                                        <label>Crédito Infonavit</label>
                                    </div>
                                    <div className="afinidad-bar">
                                        <p><span>0</span><span>25</span></p>
                                        <div className="afinidad-bar-track" style={{ position: 'relative' }}>
                                            <span className="value" style={spanStyle7}>{credito}</span>
                                            <input type="range" value={credito} min="0" max="25" onChange={handleRangeChange7} style={{ zIndex: 1 }} />
                                        </div>
                                        <label>Crédito bancario</label>
                                    </div>
                                    <div className="afinidad-bar">
                                        <p><span>0</span><span>25</span></p>
                                        <div className="afinidad-bar-track" style={{ position: 'relative' }}>
                                            <span className="value" style={spanStyle8}>{cofinanciamiento}</span>
                                            <input type="range" value={cofinanciamiento} min="0" max="25" onChange={handleRangeChange8} style={{ zIndex: 1 }} />
                                        </div>
                                        <label>Cofinanciamiento</label>
                                    </div>
                                    <div className="afinidad-bar">
                                        <p><span>0</span><span>25</span></p>
                                        <div className="afinidad-bar-track" style={{ position: 'relative' }}>
                                            <span className="value" style={spanStyle9}>{otro}</span>
                                            <input type="range" value={otro} min="0" max="25" onChange={handleRangeChange9} style={{ zIndex: 1 }} />
                                        </div>
                                        <label>Otro</label>
                                    </div>
                                </div>}
                                {opcionSeleccionadaRanger === '3' && <div className="afinidad-calific-range">
                                    <div className="afinidad-bar">
                                        <p><span>0</span><span>25</span></p>
                                        <div className="afinidad-bar-track" style={{ position: 'relative' }}>
                                            <span className="value" style={spanStyle10}>{cuatro}</span>
                                            <input type="range" value={cuatro} min="0" max="25" onChange={handleRangeChange10} style={{ zIndex: 1 }} />
                                        </div>
                                        <label>$400,000 A $490,000</label>
                                    </div>
                                    <div className="afinidad-bar">
                                        <p><span>0</span><span>25</span></p>
                                        <div className="afinidad-bar-track" style={{ position: 'relative' }}>
                                            <span className="value" style={spanStyle11}>{cinco}</span>
                                            <input type="range" value={cinco} min="0" max="25" onChange={handleRangeChange11} style={{ zIndex: 1 }} />
                                        </div>
                                        <label>$500,000 a $780,000</label>
                                    </div>
                                    <div className="afinidad-bar">
                                        <p><span>0</span><span>25</span></p>
                                        <div className="afinidad-bar-track" style={{ position: 'relative' }}>
                                            <span className="value" style={spanStyle12}>{siete}</span>
                                            <input type="range" value={siete} min="0" max="25" onChange={handleRangeChange12} style={{ zIndex: 1 }} />
                                        </div>
                                        <label>$790,000 A $890,000</label>
                                    </div>
                                </div>}
                                {opcionSeleccionadaRanger === '4' && <div className="afinidad-calific-range">
                                    <div className="afinidad-bar">
                                        <p><span>0</span><span>25</span></p>
                                        <div className="afinidad-bar-track" style={{ position: 'relative' }}>
                                            <span className="value" style={spanStyle13}>{correo}</span>
                                            <input type="range" value={correo} min="0" max="25" onChange={handleRangeChange13} style={{ zIndex: 1 }} />
                                        </div>
                                        <label>Correo</label>
                                    </div>
                                    <div className="afinidad-bar">
                                        <p><span>0</span><span>25</span></p>
                                        <div className="afinidad-bar-track" style={{ position: 'relative' }}>
                                            <span className="value" style={spanStyle14}>{telefono}</span>
                                            <input type="range" value={telefono} min="0" max="25" onChange={handleRangeChange14} style={{ zIndex: 1 }} />
                                        </div>
                                        <label>Teléfono</label>
                                    </div>
                                    <div className="afinidad-bar">
                                        <p><span>0</span><span>25</span></p>
                                        <div className="afinidad-bar-track" style={{ position: 'relative' }}>
                                            <span className="value" style={spanStyle15}>{whatsapp}</span>
                                            <input type="range" value={whatsapp} min="0" max="25" onChange={handleRangeChange15} style={{ zIndex: 1 }} />
                                        </div>
                                        <label>Whatsapp</label>
                                    </div>
                                </div>}
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            </div>
            <div className="afinidad-movil">
                <div className="container-main-movil">
                    <div className="card-afinidad-movil">
                        <div className="indicadores-coord-header-text" style={{ marginBottom: 12 }}>
                            <label>Selecciona el NSE de tu desarrollo</label>
                            <span>El nivel socio económico determina la capacidad de compra de tus prospectos. Selecciona a cual pertenece tu desarrollo.</span>
                        </div>
                        <select value={opcionSeleccionada} onChange={handleSelectChange}>
                            <option value="">Selecciona una opción</option>
                            <option value="Económico">Económico</option>
                            <option value="Medio">Medio</option>
                            <option value="Residencial">Residencial</option>
                            <option value="Plus">Plus</option>
                            <option value="Plus AAA">Plus AAA</option>
                        </select>
                        {opcionSeleccionada && nseRanges[opcionSeleccionada] && (
                            <div className="nse-price-range">
                                <div className="nse-price-wrapper">
                                    <svg className="nse-price-icon" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="12" cy="20" r="9" fill="#e8c840" stroke="#c9a800" strokeWidth="1.5"/>
                                        <text x="12" y="24.5" textAnchor="middle" fontSize="10" fill="#8a6d00" fontWeight="bold">$</text>
                                        <circle cx="20" cy="14" r="9" fill="#f0d050" stroke="#c9a800" strokeWidth="1.5"/>
                                        <text x="20" y="18.5" textAnchor="middle" fontSize="10" fill="#8a6d00" fontWeight="bold">$</text>
                                    </svg>
                                    <div className="nse-price-bar-area">
                                        <div className="nse-price-points-row">
                                            {nseRanges[opcionSeleccionada].map((t, i) => (
                                                <div key={i} className="nse-price-point-col">
                                                    <span className="nse-price-bubble">{t.value}</span>
                                                    <span className="nse-price-dot" />
                                                    <span className="nse-price-tier-label">{t.label}</span>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                    <svg className="nse-price-icon" viewBox="0 0 36 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="1" y="5" width="34" height="20" rx="3" fill="#85bb65" stroke="#5a8a3c" strokeWidth="1.5"/>
                                        <rect x="3" y="3" width="34" height="20" rx="3" fill="#97cc74" stroke="#5a8a3c" strokeWidth="1.5"/>
                                        <rect x="5" y="1" width="34" height="20" rx="3" fill="#a8d882" stroke="#5a8a3c" strokeWidth="1.5"/>
                                        <text x="22" y="15" textAnchor="middle" fontSize="9" fill="#2d5a1b" fontWeight="bold">$$$</text>
                                    </svg>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="card-afinidad-movil">
                        <div className="indicadores-coord-header-text" style={{ marginBottom: 12 }}>
                            <label>Califica las respuestas de los contactos</label>
                            <span>Asigna una puntuación basada en las preguntas de perfilación. Esto nos ayudará a entender mejor cuales son tus potenciales clientes y concretar más ventas.</span>
                        </div>
                        <select value={opcionSeleccionadaRanger} onChange={handleSelectChangeRanger}>
                            <option value="1">Tiempo de compra</option>
                            <option value="2">Forma de pago</option>
                            <option value="3">Presupuesto disponible</option>
                            <option value="4">Medio de contacto</option>
                        </select>
                        {opcionSeleccionadaRanger === '1' && <div className="afinidad-calific-range-movil">
                            <div className="afinidad-bar-movil">
                                <p>
                                    <span>0</span>
                                    <span>25</span>
                                </p>
                                <div className="afinidad-bar-track" style={{ position: 'relative' }}>
                                    <span className="value-movil" style={spanStyle4}>{compra}</span>
                                    <input
                                        type="range"
                                        value={compra}
                                        id="miInputRange"
                                        min="0"
                                        max="25"
                                        onChange={handleRangeChange4}
                                        style={{ zIndex: 1 }} />
                                </div>
                                <label>Tres meses</label>
                            </div>
                            <div className="afinidad-bar-movil">
                                <p>
                                    <span>0</span>
                                    <span>25</span>
                                </p>
                                <div className="afinidad-bar-track" style={{ position: 'relative' }}>
                                    <span className="value-movil" style={spanStyle3}>{pago}</span>
                                    <input
                                        type="range"
                                        value={pago}
                                        id="miInputRange"
                                        min="0"
                                        max="25"
                                        onChange={handleRangeChange3}
                                        style={{ zIndex: 1 }} />
                                </div>
                                <label>Seis meses</label>
                            </div>
                            <div className="afinidad-bar-movil">
                                <p>
                                    <span>0</span>
                                    <span>25</span>
                                </p>
                                <div className="afinidad-bar-track" style={{ position: 'relative' }}>
                                    <span className="value-movil" style={spanStyle2}>{presupuesto}</span>
                                    <input
                                        type="range"
                                        value={presupuesto}
                                        id="miInputRange"
                                        min="0"
                                        max="25"
                                        onChange={handleRangeChange2}
                                        style={{ zIndex: 1 }} />
                                </div>
                                <label>Un año</label>
                            </div>
                            <div className="afinidad-bar-movil">
                                <p>
                                    <span>0</span>
                                    <span>25</span>
                                </p>
                                <div className="afinidad-bar-track" style={{ position: 'relative' }}>
                                    <span className="value-movil" style={spanStyle}>{medio}</span>
                                    <input
                                        type="range"
                                        value={medio}
                                        id="miInputRange"
                                        min="0"
                                        max="25"
                                        onChange={handleRangeChange}
                                        style={{ zIndex: 1 }} />
                                </div>
                                <label>No estoy seguro</label>
                            </div>
                        </div>}
                        {opcionSeleccionadaRanger === '2' && <div className="afinidad-calific-range-movil">
                            <div className="afinidad-bar-movil">
                                <p>
                                    <span>0</span>
                                    <span>25</span>
                                </p>
                                <div className="afinidad-bar-track" style={{ position: 'relative' }}>
                                    <span className="value-movil" style={spanStyle5}>{contado}</span>
                                    <input
                                        type="range"
                                        value={contado}
                                        id="miInputRange"
                                        min="0"
                                        max="25"
                                        onChange={handleRangeChange5}
                                        style={{ zIndex: 1 }} />
                                </div>
                                <label>Contado</label>
                            </div>
                            <div className="afinidad-bar-movil">
                                <p>
                                    <span>0</span>
                                    <span>25</span>
                                </p>
                                <div className="afinidad-bar-track" style={{ position: 'relative' }}>
                                    <span className="value-movil" style={spanStyle6}>{infonavit}</span>
                                    <input
                                        type="range"
                                        value={infonavit}
                                        id="miInputRange"
                                        min="0"
                                        max="25"
                                        onChange={handleRangeChange6}
                                        style={{ zIndex: 1 }} />
                                </div>
                                <label>Crédito Infonavit</label>
                            </div>
                            <div className="afinidad-bar-movil">
                                <p>
                                    <span>0</span>
                                    <span>25</span>
                                </p>
                                <div className="afinidad-bar-track" style={{ position: 'relative' }}>
                                    <span className="value-movil" style={spanStyle7}>{credito}</span>
                                    <input
                                        type="range"
                                        value={credito}
                                        id="miInputRange"
                                        min="0"
                                        max="25"
                                        onChange={handleRangeChange7}
                                        style={{ zIndex: 1 }} />
                                </div>
                                <label>Crédito bancario</label>
                            </div>
                            <div className="afinidad-bar-movil">
                                <p>
                                    <span>0</span>
                                    <span>25</span>
                                </p>
                                <div className="afinidad-bar-track" style={{ position: 'relative' }}>
                                    <span className="value-movil" style={spanStyle8}>{cofinanciamiento}</span>
                                    <input
                                        type="range"
                                        value={cofinanciamiento}
                                        id="miInputRange"
                                        min="0"
                                        max="25"
                                        onChange={handleRangeChange8}
                                        style={{ zIndex: 1 }} />
                                </div>
                                <label>Cofinanciamiento</label>
                            </div>
                            <div className="afinidad-bar-movil">
                                <p>
                                    <span>0</span>
                                    <span>25</span>
                                </p>
                                <div className="afinidad-bar-track" style={{ position: 'relative' }}>
                                    <span className="value-movil" style={spanStyle9}>{otro}</span>
                                    <input
                                        type="range"
                                        value={otro}
                                        id="miInputRange"
                                        min="0"
                                        max="25"
                                        onChange={handleRangeChange9}
                                        style={{ zIndex: 1 }} />
                                </div>
                                <label>Otro</label>
                            </div>
                        </div>}
                        {opcionSeleccionadaRanger === '3' && <div className="afinidad-calific-range-movil">
                            <div className="afinidad-bar-movil">
                                <p>
                                    <span>0</span>
                                    <span>25</span>
                                </p>
                                <div className="afinidad-bar-track" style={{ position: 'relative' }}>
                                    <span className="value-movil" style={spanStyle10}>{cuatro}</span>
                                    <input
                                        type="range"
                                        value={cuatro}
                                        id="miInputRange"
                                        min="0"
                                        max="25"
                                        onChange={handleRangeChange10}
                                        style={{ zIndex: 1 }} />
                                </div>
                                <label>$400,000 A $490,000</label>
                            </div>
                            <div className="afinidad-bar-movil">
                                <p>
                                    <span>0</span>
                                    <span>25</span>
                                </p>
                                <div className="afinidad-bar-track" style={{ position: 'relative' }}>
                                    <span className="value-movil" style={spanStyle11}>{cinco}</span>
                                    <input
                                        type="range"
                                        value={cinco}
                                        id="miInputRange"
                                        min="0"
                                        max="25"
                                        onChange={handleRangeChange11}
                                        style={{ zIndex: 1 }} />
                                </div>
                                <label>$500,000 a $780,000</label>
                            </div>
                            <div className="afinidad-bar-movil">
                                <p>
                                    <span>0</span>
                                    <span>25</span>
                                </p>
                                <div className="afinidad-bar-track" style={{ position: 'relative' }}>
                                    <span className="value-movil" style={spanStyle12}>{siete}</span>
                                    <input
                                        type="range"
                                        value={siete}
                                        id="miInputRange"
                                        min="0"
                                        max="25"
                                        onChange={handleRangeChange12}
                                        style={{ zIndex: 1 }} />
                                </div>
                                <label>$790,000 A $890,000</label>
                            </div>
                        </div>}
                        {opcionSeleccionadaRanger === '4' && <div className="afinidad-calific-range-movil">
                            <div className="afinidad-bar-movil">
                                <p>
                                    <span>0</span>
                                    <span>25</span>
                                </p>
                                <div className="afinidad-bar-track" style={{ position: 'relative' }}>
                                    <span className="value-movil" style={spanStyle13}>{correo}</span>
                                    <input
                                        type="range"
                                        value={correo}
                                        id="miInputRange"
                                        min="0"
                                        max="25"
                                        onChange={handleRangeChange13}
                                        style={{ zIndex: 1 }} />
                                </div>
                                <label>Correo</label>
                            </div>
                            <div className="afinidad-bar-movil">
                                <p>
                                    <span>0</span>
                                    <span>25</span>
                                </p>
                                <div className="afinidad-bar-track" style={{ position: 'relative' }}>
                                    <span className="value-movil" style={spanStyle14}>{telefono}</span>
                                    <input
                                        type="range"
                                        value={telefono}
                                        id="miInputRange"
                                        min="0"
                                        max="25"
                                        onChange={handleRangeChange14}
                                        style={{ zIndex: 1 }} />
                                </div>
                                <label>Teléfono</label>
                            </div>
                            <div className="afinidad-bar-movil">
                                <p>
                                    <span>0</span>
                                    <span>25</span>
                                </p>
                                <div className="afinidad-bar-track" style={{ position: 'relative' }}>
                                    <span className="value-movil" style={spanStyle15}>{whatsapp}</span>
                                    <input
                                        type="range"
                                        value={whatsapp}
                                        id="miInputRange"
                                        min="0"
                                        max="25"
                                        onChange={handleRangeChange15}
                                        style={{ zIndex: 1 }} />
                                </div>
                                <label>Whatsapp</label>
                            </div>
                        </div>}
                    </div>
                </div>
            </div>
        </>
    )
}

export { Afinidad }